import { createStore } from 'vuex'
// const URL = 'http://localhost:5005/';
const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';

export default createStore({
  state: {
    URL_APP: URL,
    URL_APP_SIMPEG: URL_SIMPEG,
    URL_SLIDER: URL + "api/v1/publish_dprd_slider/",
    URL_SEJARAH: URL + "api/v1/publish_dprd_sejarah/",
    ADD_URL_BERITA: URL + "api/v1/web_publish_berita/",
    ADD_URL_PROFIL: URL + "api/v1/publish_dprd_profil_kantor/",
    ADD_URL_TUGAS: URL + "api/v1/publish_dprd_tugas_pokok/",
    ADD_URL_STRUKTUR: URL + "api/v1/publish_dprd_struktur_organisasi/",
    ADD_URL_PEGAWAI: URL + "api/v1/publish_dprd_profilstruktural/",

    ADD_URL_DEWAN: URL + "api/v1/publish_dprd_anggota/",
    ADD_URL_MASA_JABATAN: URL + "api/v1/publish_dprd_masa_jabatan/",
    ADD_URL_FRAKSI: URL + "api/v1/publish_dprd_fraksi/",
    ADD_URL_KOMISI: URL + "api/v1/publish_dprd_komisi/",
    ADD_URL_BADAN: URL + "api/v1/publish_dprd_badan/",



    URL_ALAT_BPP: URL + "api/v1/publish_dprd_bpp/",
    URL_ALAT_BK: URL + "api/v1/publish_dprd_bk/",
    URL_ALAT_BM: URL + "api/v1/publish_dprd_bm/",
    URL_ALAT_BA: URL + "api/v1/publish_dprd_ba/",




    LAYANAN_BANGGA: URL + "api/v1/publish_dprd_bangga/",
    LAYANAN_ALOKON: URL + "api/v1/publish_dprd_alokon/",
    LAYANAN_BKB: URL + "api/v1/publish_dprd_bkb/",
    LAYANAN_BKL: URL + "api/v1/publish_dprd_bkl/",
    LAYANAN_BKR: URL + "api/v1/publish_dprd_bkr/",
    LAYANAN_FASKER: URL + "api/v1/publish_dprd_fasker/",
    LAYANAN_SWASTA: URL + "api/v1/publish_dprd_swasta/",
    LAYANAN_UPPKS: URL + "api/v1/publish_dprd_uppks/",
    LAYANAN_GENRE: URL + "api/v1/publish_dprd_genre/",
    LAYANAN_KIE: URL + "api/v1/publish_dprd_kie/",
    LAYANAN_PANKEL: URL + "api/v1/publish_dprd_penkel/",
    LAYANAN_PIL: URL + "api/v1/publish_dprd_pil/",
    LAYANAN_PPKBD: URL + "api/v1/publish_dprd_ppkbd/",
    LAYANAN_SPPKBD: URL + "api/v1/publish_dprd_sppkbd/",

    URL_DOKUMEN: URL + "api/v1/publish_dprd_dokumen/",
    URL_DATA: URL + "api/v1/publish_dprd_data/",
    URL_JDIH: URL + "api/v1/publish_dprd_jdih/",




    ADD_FOTO: URL + "api/v1/publish_dprd_foto/",
    ADD_VIDEO: URL + "api/v1/publish_dprd_video/",
    URL_INFOGRAFIS: URL + "api/v1/publish_dprd_infografis/",
    FILE_LOAD: URL + "uploads/",
    UNIT_KERJA: 'QhX8raiTCH8wqz5jK',
    TAHUN: '2019'
  }
})